<template>
  <v-card outlined>
    <v-card-title v-if="title">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <v-expansion-panels>
        <template v-for="(entry, angleIndex) in page.data">
          <v-expansion-panel :key="`${module}-${angleIndex}`">
            <v-expansion-panel-header>
              <v-container class="d-flex pa-0">
                <v-checkbox
                  v-model="selected.angles"
                  class="mt-0 pt-4"
                  :value="angleIndex"
                  color="primary"
                  outlined
                  dense
                  hide-details
                />
                <v-container class="pl-0">
                  <v-text-field
                    v-model="entry.titre_discover"
                    label="Titre de l'angle"
                    dense
                    outlined
                    hide-details
                    class="mt-1"
                    @click.stop
                  />
                  <v-text-field
                    v-model="entry.source_url"
                    label="URL source (optionnel)"
                    dense
                    outlined
                    hide-details="auto"
                    class="mt-2"
                    :rules="[urlRule]"
                    @click.stop
                  />
                </v-container>
              </v-container>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Affichage des informations LLM -->
              <v-card class="mb-4" outlined>
                <v-card-text>
                  <div class="mb-3">
                    <strong>Angle :</strong> {{ entry.angle }}
                  </div>
                  <div class="mb-3">
                    <strong>Preuve :</strong> {{ entry.preuve }}
                  </div>
                  <div class="mb-3">
                    <strong>Potentiel Discover :</strong>
                    {{ entry.potentiel_discover }}/10
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.truncateCell {
  max-width: 250px;
  max-height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";

import compact from "lodash/compact";
import isArray from "lodash/isArray";

import useProxy from "@/hooks/useProxy";
import { validateKeys } from "@/utils/validation";

export default {
  name: "KwAngleResultsTable",
  props: {
    title: {
      type: String,
      default: "",
    },
    module: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
      validator(value) {
        if (!isArray(value)) {
          return false;
        }

        // Allow empty arrays
        if (value.length === 0) {
          return true;
        }

        return value.every(
          (entry) =>
            typeof entry === "object" &&
            entry !== null &&
            typeof entry.angle === "string" &&
            typeof entry.titre_discover === "string" &&
            typeof entry.preuve === "string" &&
            typeof entry.potentiel_discover === "number"
        );
      },
    },
  },
  setup(props, { emit }) {
    const { store } = useProxy();

    const selected = reactive({
      angles: [],
    });

    const page = reactive({
      data: [],
    });

    // =>  METHODS
    const isValidUrl = (url) => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    const urlRule = (value) => {
      if (!value || value === "") return true;
      return isValidUrl(value) || "URL invalide";
    };

    const initPage = () => {
      selected.angles = []; // By default, no angle is selected

      page.data = props.data.map((entry) => ({
        ...entry,
        titre_discover: entry.titre_discover || entry.angle,
        source_url: entry.source_url || "",
      }));
    };

    // =>  COMPUTED
    const site = computed(() => store.getters["aiFactory/getSelectedSites"]);

    // =>  WATCH
    watch(selected, () => {
      const selections = page.data.reduce((accumulator, entry, angleIndex) => {
        if (!selected.angles.includes(angleIndex)) {
          return [...accumulator];
        }

        const draft = {
          angle: entry.angle,
          titre_discover: entry.titre_discover,
          preuve: entry.preuve,
          potentiel_discover: entry.potentiel_discover,
          source_url: entry.source_url,
        };

        return [...accumulator, draft];
      }, []);
      emit("valueChanged", props.module, selections);
    });

    watch(
      () => props.data,
      () => initPage()
    );

    // =>  HOOKS
    onMounted(async () => {
      initPage();
    });

    // =>  DATA
    return {
      page,
      selected,
      urlRule,
    };
  },
};
</script>
